import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { CustomProduct } from '@product/const';
import { CustomMediaComponent } from '@sdvor/shared/ui';
import { CurrentProductService } from '@spartacus/storefront';
import { Observable } from 'rxjs';
@Component({
  selector: 'sd-product-compact-title',
  imports: [CustomMediaComponent],
  templateUrl: './product-compact-title.component.html',
  styleUrls: ['./product-compact-title.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProductCompactTitleComponent {
  private readonly currentProductService = inject(CurrentProductService);

  readonly product = input<CustomProduct | undefined>(undefined);

  private readonly currentProduct = toSignal(this.currentProductService.getProduct() as Observable<CustomProduct>);

  readonly resolvedProduct = computed(() => this.product() ?? this.currentProduct());
}
